import { lazy, Suspense } from "react";

const LazyAppModalRegistry = lazy(async () => {
  const [{ ModalsPanelsRegistry }, { RegisteredModal }] = await Promise.all([
    import("./@libs/modal-panels/modal-panels.tsx"),
    import("./modal-registry.tsx"),
  ]);

  return {
    default: () => <ModalsPanelsRegistry modals={RegisteredModal} />,
  };
});

export function AppModalRegistry() {
  return (
    <Suspense fallback={null}>
      <LazyAppModalRegistry />
    </Suspense>
  );
}
